import { useEffect } from 'react';
import { ApiCallResultStatus } from 'store/apiCallResultStatus';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { getCurrentFamilyMember, getOtherFamilyMembers } from '../familySelectors';
import { getFamilyMembersAsync } from '../familySlice';

export const useFamily = () => {
  const dispatch = useAppDispatch();
  const [allFamilyMembers, familyMembersLoadingStatus, otherFamilyMembers, currentFamilyMember] = useAppSelector((state) => [
    state.family.familyMembers,
    state.family.getFamilyMembersStatus,
    getOtherFamilyMembers(state.family),
    getCurrentFamilyMember(state.family),
  ]);

  useEffect(() => {
    if (familyMembersLoadingStatus === ApiCallResultStatus.DEFAULT) {
      dispatch(getFamilyMembersAsync());
    }
  }, [dispatch, familyMembersLoadingStatus]);

  return { allFamilyMembers, currentFamilyMember, otherFamilyMembers, familyMembersLoadingStatus };
};
